// extracted by mini-css-extract-plugin
module.exports = {"noData":"_45fd2b2","noDataButtons":"_9feaf68"};